export default __webpack_public_path__ + "static/media/about-us.812a996a.png";